import React from 'react';
import PageLayout from '../../layout/PageLayout';
import PurchasingHistory from '../../layout/PurchasingHistory/PurchasingHistory';

const PurchasingHistoryPage: React.FC = () => (
  <PageLayout>
    <PurchasingHistory />
  </PageLayout>
);

export default PurchasingHistoryPage;
